import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RowClick from '../../../../common/RowClick';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
  formatPercent,
} from '../../../../helpers/Text';
import { REDUCER_NAME } from '../reducer';
import Const from './Const';
import '../../../technical.scss';
import { compose } from 'redux';
import TradingViewUrl from '../../../../common/TradingViewUrl';
import { I18n } from 'react-redux-i18n';

class TableOverview extends React.PureComponent {
  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectDeceptiveDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          thStyle: { width: '40px' },
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <div className="pl-10">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </div>
            </CellHover>
          ),
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text), 2, true)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.PERCENT_PRICE_CHANGE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            const volume = getDataFollowKeyByDot(item, listColumn.VOLUME);
            const displayText =
              volume === 0 ? '--' : formatTextFloat(formatPercent(text)) + '%';
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {displayText}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.VOLUME], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text), 2, true)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.CE_FL], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          thTooltip: I18n.t('tasignals.overviewContent.ceflTooltip'),
          render: text => {
            if (text === true)
              return (
                <div className="text-center d-flex align-items-center justify-content-center">
                  <i className="icon-dot text-s-color-3" />
                </div>
              );
            else {
              return <div style={{ height: 24 }} />;
            }
          },
        };
      }

      if (_.includes([listColumn.PRESSING], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          thTooltip: I18n.t('tasignals.overviewContent.pressingTooltip'),
          render: (text, item) => {
            if (text === true)
              return (
                <div className="text-center">
                  <span className="text-center text-s-color-3">
                    <i className="icon-dot" />
                  </span>
                </div>
              );
            else {
              return '';
            }
          },
        };
      }

      if (_.includes([listColumn.CANCELED], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          thTooltip: I18n.t('tasignals.overviewContent.cancelledTooltip'),
          render: (text, item) => {
            if (text === true) {
              return (
                <div className="text-center">
                  <span className="text-center text-s-color-3">
                    <i className="icon-dot" />
                  </span>
                </div>
              );
            } else {
              return '';
            }
          },
        };
      }

      if (_.includes([listColumn.AGGRESSIVE], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          thTooltip: I18n.t('tasignals.overviewContent.aggressiveTooltip'),
          render: (text, item) => {
            if (text === true) {
              return (
                <div className="text-center">
                  <span className="text-center text-s-color-3">
                    <i className="icon-dot" />
                  </span>
                </div>
              );
            } else {
              return '';
            }
          },
        };
      }

      if (_.includes([listColumn.CLOSING], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          thTooltip: I18n.t('tasignals.overviewContent.closingTooltip'),
          render: (text, item) => {
            if (text === true)
              return (
                <div className="text-center">
                  <span className="text-center text-s-color-3">
                    <i className="icon-dot" />
                  </span>
                </div>
              );
            else {
              return '';
            }
          },
        };
      }

      return {
        ...result,
        render: text => text,
      };
    });

  render() {
    const { isLoading } = this.props;
    const { ids } = this.props;
    return (
      <RowClick>
        {onRowClick => (
          <Table
            clickRow={onRowClick}
            ids={ids}
            isLoading={isLoading}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            schema={this.schema(Const.listColumn, 'tasignals.overviewHeader')}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    ids: state[REDUCER_NAME].listDeceptiveDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableOverview);
